import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
  ElementRef,
  Renderer2,
} from '@angular/core'
import { CommonModule, isPlatformBrowser, DatePipe } from '@angular/common'
import { NavbarComponent } from '../navbar/navbar.component'
import { AuthService } from '../../pages/auth/auth.service'
import { Subscription } from 'rxjs'
import { RouterModule } from '@angular/router'
import { ProjectComponent } from '../project/project.component'

import { MatDialogModule } from '@angular/material/dialog'
import { BannerComponent } from '../banner/banner.component'
import { MatDialog } from '@angular/material/dialog'
import { FormPesanComponent } from './form-pesan/form-pesan.component'
import { HttpClientModule } from '@angular/common/http'
import { HomeService } from './home.service'
import { NgForm } from '@angular/forms';
import { SpinnerComponent } from '../spinner/spinner.component'
import * as moment from 'moment';
import { SettingService } from '../../pages/admin/setting.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    HttpClientModule,
    NavbarComponent,
    FormPesanComponent,
    MatDialogModule,
    ProjectComponent,
    BannerComponent,
    SpinnerComponent,
    RouterModule,
  ],
  encapsulation:  ViewEncapsulation.None,
  providers: [HomeService],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  companyName: any;
  message: any;
  isAuthenticated = false
  userSub!: Subscription
  widthScreen = 0
  fontSize: any
  buttonColor = false
  className!: string
  file: any
  isLoading = false;
  isAdmin = false;
  dataStory: any;
  getType: any;
  dataNavbar = [
    {
      name: 'aga'
    },
    {
      name: 'Course',
    },
    {
      name: 'About'
    },
    {
      name: 'Work'
    },
    {
      name:'Story'
    }
  ]

  placeHolderName = 'coba dulu'
  role: any;
  constructor(
    private authService: AuthService,
    private homeService: HomeService,
    public dialog: MatDialog,
    private render: Renderer2,
    private elementRef: ElementRef,
    private settingService: SettingService,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.widthScreen = window.innerWidth
    }
    console.log('this. is my setting', this.settingService.baseUrl)
    console.log(this.widthScreen, 'width screen')
  }


  ngOnInit(): void {
    this.role = localStorage.getItem('role')
    if(this.role == 'admin'){
      this.isAdmin = true
    }
    this.userSub = this.authService.data$.subscribe((user) => {
      this.isAuthenticated = user ? true : false //!user ? true : false
      console.log(`isAuthenticated: ${this.isAuthenticated}`)
    })
    this.widthScreen < 997
      ? (this.fontSize = '60px')
      : (this.fontSize = '40px')

    this.homeService.statusForm.subscribe()

    this.doGetStory();
  }



  changeColor() {
    this.buttonColor = !this.buttonColor
  }


  doChange(color: string) {
    switch (color) {
      case 'dark':
        this.className = 'dark' ? 'dark' : 'blueviolet'
        break
      case 'white':
        this.className = 'white' ? 'white' : 'blueviolet'
        break
      case 'blue':
        this.className = 'blue' ? 'blue' : 'blueviolet'
        break
      default:
        this.className = 'blueviolet'
    }
    console.log(this.className)
  }
  downloadCv() {
    this.file = '../../../assets/file/cvterbaru-dikompresi new.pdf'
    window.open(this.file)
  }


  // ngOnDestroy(): void {
  //     this.authService.user.unsubscribe()
  // }

  openDialog() {
    console.log('res')
    this.dialog.open(FormPesanComponent, { panelClass: 'custom-dialog-container' })
  }

  doSendToHire(form: NgForm) {
    this.isLoading = true;
    const bodyForm = {
      companyName: form.value.companyName,
      message: form.value.message,
    }
    this.homeService.sendHire(bodyForm).subscribe(
      (value: any) => {
        this.isLoading = false;
        console.log(value)
      },
      (error) => {
        this.isLoading = false;
        console.log(error)
      },
    )
  }
  clickToDark(event: any){
    console.log(event, 'evenet parent');
    this.render.setStyle(this.elementRef.nativeElement, 'background-color', event)
  }
  showHideNavbar(name: any){
    this.getType = name;
    console.log(name,);
  }

  doGetStory(){
    this.homeService.getStory().subscribe((value: any) => {
      this.dataStory = value.data
      const datepipe: DatePipe = new DatePipe('en-US')

      this.dataStory.map((item: any) => item.createdAt = datepipe.transform(item.createdAt, 'dd-MMM-YYYY HH:mm:ss'))
    })
  }
}
